<template>
<div class="chapter">
<div class="inner_page">
<h1 class="section">TABLE OF CONTENTS</h1>
<p class="crt1"><span class="hlink" href="#/tp" title="Link target outside of Sample">Title Page</span></p>
<p class="crt"><span class="hlink" href="#/cop" title="Link target outside of Sample">Copyright</span></p>
<p class="crt"><a class="hlink" href="#/ded">Dedication</a></p>
<p class="crt"><a class="hlink" href="#/epigraph">Epigraph</a></p>
<p class="crt1"><a class="hlink" href="#/c01">Chapter One</a></p>
<p class="crt"><a class="hlink" href="#/c02">Chapter Two</a></p>
<p class="crt"><a class="hlink" href="#/c03">Chapter Three</a></p>
<p class="crt"><span class="hlink" href="#/c04" title="Link target outside of Sample">Chapter Four</span></p>
<p class="crt"><span class="hlink" href="#/c05" title="Link target outside of Sample">Chapter Five</span></p>
<p class="crt"><span class="hlink" href="#/c06" title="Link target outside of Sample">Chapter Six</span></p>
<p class="crt"><span class="hlink" href="#/c07" title="Link target outside of Sample">Chapter Seven</span></p>
<p class="crt"><span class="hlink" href="#/c08" title="Link target outside of Sample">Chapter Eight</span></p>
<p class="crt"><span class="hlink" href="#/c09" title="Link target outside of Sample">Chapter Nine</span></p>
<p class="crt"><span class="hlink" href="#/c10" title="Link target outside of Sample">Chapter Ten</span></p>
<p class="crt"><span class="hlink" href="#/c11" title="Link target outside of Sample">Chapter Eleven</span></p>
<p class="crt"><span class="hlink" href="#/c12" title="Link target outside of Sample">Chapter Twelve</span></p>
<p class="crt"><span class="hlink" href="#/c13" title="Link target outside of Sample">Chapter Thirteen</span></p>
<p class="crt"><span class="hlink" href="#/c14" title="Link target outside of Sample">Chapter Fourteen</span></p>
<p class="crt"><span class="hlink" href="#/c15" title="Link target outside of Sample">Chapter Fifteen</span></p>
<p class="crt"><span class="hlink" href="#/c16" title="Link target outside of Sample">Chapter Sixteen</span></p>
<p class="crt"><span class="hlink" href="#/c17" title="Link target outside of Sample">Chapter Seventeen</span></p>
<p class="crt"><span class="hlink" href="#/c18" title="Link target outside of Sample">Chapter Eighteen</span></p>
<p class="crt"><span class="hlink" href="#/c19" title="Link target outside of Sample">Chapter Nineteen</span></p>
<p class="crt"><span class="hlink" href="#/c20" title="Link target outside of Sample">Chapter Twenty</span></p>
<p class="crt"><span class="hlink" href="#/c21" title="Link target outside of Sample">Chapter Twenty-One</span></p>
<p class="crt"><span class="hlink" href="#/c22" title="Link target outside of Sample">Chapter Twenty-Two</span></p>
<p class="crt"><span class="hlink" href="#/c23" title="Link target outside of Sample">Chapter Twenty-Three</span></p>
<p class="crt"><span class="hlink" href="#/c24" title="Link target outside of Sample">Chapter Twenty-Four</span></p>
<p class="crt"><span class="hlink" href="#/c25" title="Link target outside of Sample">Chapter Twenty-Five</span></p>
<p class="crt"><span class="hlink" href="#/authorsnote" title="Link target outside of Sample">Author’s Note</span></p>
<p class="crt1"><span class="hlink" href="#/end01" title="Link target outside of Sample">Bonus Material</span></p>
<p class="crt"><span class="hlink" href="#/end02" title="Link target outside of Sample">Padma Celebrates Buy Day</span></p>
<p class="crt"><span class="hlink" href="#/end03" title="Link target outside of Sample">Labor in SF, or Make the Robots Do It</span></p>
<p class="crt"><span class="hlink" href="#/end04" title="Link target outside of Sample">The First Strike I Ever Saw</span></p>
<p class="crt"><span class="hlink" href="#/end05" title="Link target outside of Sample">The Big Idea - The Cloud Goes On Strike</span></p>
<p class="crt"><span class="hlink" href="#/end06" title="Link target outside of Sample">My Favorite Bit - John Galt’s Powerpoint</span></p>
<p class="crt"><span class="hlink" href="#/end07" title="Link target outside of Sample">Sci Fi Bulletin - Writing About Politics and Other Professional Hazards</span></p>
<p class="crt"><span class="hlink" href="#/end08" title="Link target outside of Sample">SFF World - Writing Women Characters (Wait, Aren't You a Dude?)</span></p>
<p class="crt"><span class="hlink" href="#/end09" title="Link target outside of Sample">Grilled Lime Chicken Tacos</span></p>
<p class="crt1"><span class="hlink" href="#/ack" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="crt"><span class="hlink" href="#/ata" title="Link target outside of Sample">About the Author</span></p>
<p class="crt"><span class="hlink" href="#/alsoby" title="Link target outside of Sample">Also by Adam Rakunas</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?26499ae5